module.exports = __webpack_public_path__ + "static/img/Charlie-Curnow.e403926.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Charlie-Curnow.jpg
// module id = h2K3
// module chunks = 0